import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { FILTER_GET_COLOR, FILTER_GET_DESIGNER_SELLER, FILTER_GET_MASTER, FILTER_GET_SHIPPINGTIME, FILTER_GET_SIZE } from '../SagaAction/actions'
import { getColorDataFailure, getColorDataRequest, getColorDataSuccess, getDesignerDataFailure, getDesignerDataRequest, getDesignerDataSuccess, getFilterMasterFailure, getFilterMasterRequest, getFilterMasterSuccess, getShippingTimeDataFailure, getShippingTimeDataRequest, getShippingTimeDataSuccess, getSizeDataFailure, getSizeDataRequest, getSizeDataSuccess } from '../Slices/FiltergetSlice'
import requestApi from '../../utils/request'

function* filterGetColor (){
    try {
        yield put (getColorDataRequest())
        const {data} = yield requestApi.post("color")
        yield put (getColorDataSuccess(data))
    } catch (error) {
        yield put (getColorDataFailure(error))
    }
}
function* filterGetSize (){
    try {
        yield put (getSizeDataRequest())
        const {data} = yield requestApi.post("size")
        yield put (getSizeDataSuccess(data))
    } catch (error) {
        yield put (getSizeDataFailure(error))
    }
}
function* filterGetShippingTime (){
    try {
        yield put (getShippingTimeDataRequest())
        const {data} = yield requestApi.post("shippingTime")
        yield put (getShippingTimeDataSuccess(data))
    } catch (error) {
        yield put (getShippingTimeDataFailure(error))
    }
}

function* filterGetDesignerSeller (){
    try {
        yield put (getDesignerDataRequest())
        const {data} = yield requestApi.post("seller-list")
        yield put (getDesignerDataSuccess(data))
    } catch (error) {
        yield put (getDesignerDataFailure(error))
    }
}

function* getFilterMaster(params){
    try {
        yield put (getFilterMasterRequest())
        const {data} = yield requestApi.post("master-list",params.payload)
        yield put (getFilterMasterSuccess(data))
        if(typeof params.callback === "function"){
            yield params.callback(data)
        }
    } catch (error) {
        yield put (getFilterMasterFailure(error))
    }
}


function* FiltergetSaga() {
  yield takeLatest(FILTER_GET_COLOR, filterGetColor)
  yield takeLatest(FILTER_GET_SIZE, filterGetSize)
  yield takeLatest(FILTER_GET_SHIPPINGTIME, filterGetShippingTime)
  yield takeLatest(FILTER_GET_DESIGNER_SELLER, filterGetDesignerSeller)
yield takeLatest(FILTER_GET_MASTER,getFilterMaster)
}

export default FiltergetSaga